<template>
  <div class="filter-bar ui grid">
    <div class="ui two column stackable grid form">
      <div class="column">
        <input
          type="text"
          v-model="filterText"
          class
          @keyup.enter="doFilter"
          placeholder="Search for machines, assemblies, etc....."
        />
      </div>

      <div class="column">
        <button class="ui primary button" @click="doFilter">Search</button>
        <button class="ui button" @click="resetFilter">Reset</button>
      </div>
    </div>
  </div>
</template>

  <script>
export default {
  data() {
    return {
      filterText: ""
    };
  },
  methods: {
    doFilter() {
      this.$events.fire("filter-set", this.filterText);  
    },
    resetFilter() {
      this.filterText = ""; // clear the text in text input
      this.$events.fire("filter-reset");
    }
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  }
};
</script>